import apiClient from './client'
import { apiEndpoints } from '@/config/api'

/**
 * Checkout API Module
 * 
 * Handles checkout process and order placement.
 */

export const checkoutApi = {
  /**
   * Place order
   * @param {Object} data - Checkout data
   * @param {string} data.first_name - First name
   * @param {string} data.last_name - Last name
   * @param {string} data.email - Email address
   * @param {string} data.phone - Phone number
   * @param {string} data.shipping_address - Shipping address
   * @param {string} data.shipping_city - Shipping city
   * @param {string} data.shipping_state - Shipping state
   * @param {string} data.shipping_postal_code - Shipping postal code
   * @param {string} data.shipping_country - Shipping country
   * @param {string} data.billing_address - Billing address
   * @param {string} data.billing_city - Billing city
   * @param {string} data.billing_state - Billing state
   * @param {string} data.billing_postal_code - Billing postal code
   * @param {string} data.billing_country - Billing country
   * @param {boolean} data.same_as_shipping - Use shipping address for billing
   * @param {string} data.notes - Order notes
   * @param {string} data.shipping_method - Shipping method (standard, express, overnight)
   * @returns {Promise} Order confirmation
   */
  async checkout(data) {
    const response = await apiClient.post(apiEndpoints.checkout.checkout, data)
    return response.data
  },
}

export default checkoutApi
